import { Link } from "react-router-dom";
import Paginator from "../ui/Paginator";
import { useEffect, useState } from "react";
import EnterpriseService from "../../common/services/enterprise-service";
import { Col, Input, InputGroup, Row } from "reactstrap";
import Loader from "../ui/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function CompanyMembers({ container, company }) {
  const [members, setMembers] = useState([]);
  const es = new EnterpriseService();
  const [totalPages, setTotalPages] = useState(0);
  const [totalMembers, setTotalMembers] = useState(0);
  const [pagination, setPagination] = useState({ page: 1, perPage: 60 });
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const handleRowsPerPageChange = (perPage) => {
    setPagination({ ...pagination, page: 1, perPage: perPage });
  };

  const handlePageClick = (event) => {
    setPagination({ ...pagination, page: event.selected + 1 });
  };

  const getMembers = async () => {
    setLoading(true);
    const result = await es.getMembers(company, pagination);
    setMembers(result.data);
    setTotalPages(result.last_page);
    if (result.total != null) setTotalMembers(result.total);
    setLoading(false);
  };

  useEffect(() => {
    getMembers();
  }, [pagination.page, pagination.perPage]);

  const filteredMembers = searchTerm.trim().length >= 2
    ? members.filter((m) =>
        m.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (m.role != null && m.role.name.toLowerCase().includes(searchTerm.toLowerCase()))
      )
    : members;

  return (
    <div>
      <div className="filters-toolbar mb-3 d-flex align-items-center gap-3 flex-wrap">
        <InputGroup style={{ maxWidth: 280 }}>
          <span className="input-group-text">
            <FontAwesomeIcon icon="search" />
          </span>
          <Input
            placeholder={container.localeManager.strings.searchForPlayerName || "Search member…"}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
        {totalMembers > 0 && (
          <span className="text-muted ms-auto">
            {totalMembers} {container.localeManager.strings.members || "members"}
          </span>
        )}
      </div>

      {loading && <Loader />}

      {!loading && (
        <>
          <Paginator
            showRowsPerPage={true}
            forcePage={pagination.page - 1}
            totalPages={totalPages}
            handlePageClick={handlePageClick}
            handleRowsPerPageChange={handleRowsPerPageChange}
            rowsPerPageSelected={pagination.perPage}
            rowsPerPage={[60, 90, 120]}
          />
          <Row className="g-2 my-3">
            {filteredMembers.map((m) => (
              <Col key={m.id} xs={12} md={6} xl={4}>
                <Link to={`/user/${m.id}`} className="company-member-card">
                  <img
                    src={m.avatar_url}
                    className="company-member-avatar"
                    alt={m.name}
                  />
                  <div className="company-member-info">
                    <span className="company-member-name">{m.name}</span>
                    {m.role != null && (
                      <span
                        className="company-member-role"
                        style={m.role.color ? { color: m.role.color } : undefined}
                      >
                        {m.role.name}
                      </span>
                    )}
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
          {filteredMembers.length === 0 && searchTerm.length >= 2 && (
            <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed p-4">
              {container.localeManager.strings.noResults || "No members found."}
            </div>
          )}
          <Paginator
            rowsPerPage={[60, 90, 120]}
            forcePage={pagination.page - 1}
            totalPages={totalPages}
            handlePageClick={handlePageClick}
            handleRowsPerPageChange={handleRowsPerPageChange}
            rowsPerPageSelected={pagination.perPage}
          />
        </>
      )}
    </div>
  );
}
